import { forwardRef, type HTMLAttributes } from "react"
import { cn } from "@/lib/cn"

export const Skeleton = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function Skeleton({ className, ...rest }, ref) {
    return (
      <div
        ref={ref}
        aria-hidden="true"
        data-testid="compass-skeleton"
        className={cn(
          "animate-pulse rounded-md bg-markv-surface-200",
          className,
        )}
        {...rest}
      />
    )
  },
)
